import { render } from "./ExpenseTypeAutocomplete.vue?vue&type=template&id=51b2e68f&scoped=true"
import script from "./ExpenseTypeAutocomplete.vue?vue&type=script&lang=js"
export * from "./ExpenseTypeAutocomplete.vue?vue&type=script&lang=js"

import "./ExpenseTypeAutocomplete.vue?vue&type=style&index=0&id=51b2e68f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b2e68f"]])

export default __exports__